import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconTv$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconTv extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '6445c7d1aa717de3a3b7fd1adf66fa9086e1c8ee', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '35dd4aa04719877da526bd53b48e17a1ba03a86b', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '30c513773661cdf2f5a758abe979cd2ce6dbf5a9', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.5 8.218h-5.36l2.43-3a.5.5 0 0 0-.08-.7l-.39-.3a.49.49 0 0 0-.7.08l-3.17 3.92-5.05-5.07a.5.5 0 0 0-.71 0l-.35.35a.5.5 0 0 0 0 .71l4 4H3.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-9.99a.5.5 0 0 0-.5-.5m-1 9.5h-13v-8h13z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-tv", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-tv"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-tv":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconTv$1);
            }
            break;
    } });
}

const CosmosIconTv = CosmosIconTv$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconTv, defineCustomElement };
